export default __webpack_public_path__ + "static/media/icon3.c99f84fb.png";